import styled from 'styled-components';
import { tokens } from '../../../../../design/tokens';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.space.xs};
`;

export const Primary = styled.strong`
  color: ${tokens.color.textWhite};
`;

export const Secondary = styled.span`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
  word-break: break-word;
`;
